import StartPlayingIcon from "components/Profile/components/StartPlayingIcon";
import CoffeeMakerTwoToneIcon from "@mui/icons-material/CoffeeMakerTwoTone";
import WbSunnyTwoToneIcon from "@mui/icons-material/WbSunnyTwoTone";
import NightlightTwoToneIcon from "@mui/icons-material/NightlightTwoTone";
import Brightness6TwoToneIcon from "@mui/icons-material/Brightness6TwoTone";
import BedTwoToneIcon from "@mui/icons-material/BedTwoTone";

export const playerTypes = [
    { id: 0, label: "Player", surveyAnswer: "Player only.", paginateParam: "Player" },
    { id: 1, label: "DM", surveyAnswer: "DM only.", paginateParam: "DM" },
    { id: 2, label: "Professional GM", surveyAnswer: "professionalGM", paginateParam: "professionalGM" },
];

export const agesConstants = [
    { id: 0, label: "18-24" },
    { id: 1, label: "25-34" },
    { id: 2, label: "35-44" },
    { id: 3, label: "45+" },
];

export const VTTOptions = [
    { id: 0, label: "Above VTT", img: null },
    { id: 1, label: "Arkenforge VTT", img: "arkenforge.svg" },
    { id: 2, label: "Demiplane", img: "demiplane.svg" },
    { id: 3, label: "Discord", img: null },
    { id: 4, label: "Fantasy Grounds", img: null },
    { id: 5, label: "Foundry", img: null },
    { id: 6, label: "Owlbear Rodeo", img: null },
    { id: 7, label: "Quest Portal", img: "quest_portal.svg" },
    { id: 8, label: "Roll20", img: null },
];

export const eventBadges = [
    {
        id: 2,
        image: "con2023.svg",
        name: "Con 2023",
    },
    {
        id: 14,
        image: "bigbad_con.svg",
        name: "Big Bad Con",
    },
];

// there are a number of legacy questions we cycle through at the end of the profile
export const optional_questions = [
    {
        title: "Top things brought as player",
        key: "thingsBroughtAsPlayer",
        icon: "/additional-questions/topThings.svg",
        editable: false,
    },
    {
        title: "Open to homebrew?",
        key: "homebrewRuleChanges",
        icon: "/additional-questions/openHomebrew.svg",
        editable: false,
    },
    {
        title: "Would you play a streamed game?",
        key: "streamedTTRPG",
        answers: ["Yes. I do it all the time.", "Yeah, I've done it before.", "Sure, I'd be open to it.", "No way."],
        icon: "/additional-questions/streamedGame.svg",
        editable: true,
        order: 1,
    },
    {
        title: "My Favorite Character",
        key: "favoriteCharacterDescription",
        icon: "/additional-questions/gandalf.svg",
        editable: false,
    },
    {
        title: "What style of campaign do you prefer?",
        key: "preferredCampaignStyle",
        answers: ["High-level/Epic", "Mid-level", "Low-level/gritty", "I'm good with anything."],
        icon: "/additional-questions/styleCampaing.svg",
        editable: true,
        order: 2,
    },
    {
        title: "How picky when looking for games",
        key: "gamePickiness",
    },
    {
        title: "Ok joining existing game",
        key: "joiningExistingGames",
    },

    {
        title: "Number of games run",
        key: "numberOfGamesRun",
        type: "number",
        icon: "/additional-questions/numberGames.svg",
        editable: true,
        order: 0,
    },
    {
        title: "Opportunities created",
        key: "opportunitiesCreated",
    },
    {
        title: "Campaign style",
        key: "campaignStyle",
    },
    {
        title: "Years running games",
        key: "numberOfYearsRunningGame",
    },
    {
        title: "Strengths as a Game Master",
        key: "strengths",
    },
    {
        title: "As a Game Master how important are rules?",
        key: "ruleImportance",
        icon: "/additional-questions/gameMasterRules.svg",
        editable: false,
    },
    {
        title: "Do you homebrew as a Game Master?",
        key: "homebrewDM",
    },
    {
        title: "DO you stream games?",
        key: "streamGames",
    },
    {
        title: "Would you run a new TTRPG?",
        key: "newGameDM",
    },
    {
        title: "What tools do you use?",
        key: "toolsUsed",
    },
    // {
    //     title: "Which VTT do you use?",
    //     key: "virtualTableTops",
    // },
    {
        title: "Do characters die in your games?",
        key: "characterKillingDM",
    },
];

export const profileSocialMedia = [
    {
        title: "Twitter",
        key: "twitter_name",
        icon: <img src="/twitter_logotype.png" style={{ borderRadius: "7px" }} alt="Twitter" />,
        url: "https://www.twitter.com/",
        message: "We can pull your avatar and cover preferences from your Twitter, please enter your username here:",
        warning: "Once you connected your account, you won’t be able to remove it.",
    },
    {
        title: "Instagram",
        key: "instagram",
        icon: (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.99998 1.80184C12.6701 1.80184 12.9864 1.812 14.0408 1.86011C15.0158 1.90461 15.5453 2.06752 15.8977 2.20443C16.3644 2.38583 16.6976 2.60257 17.0475 2.95248C17.3974 3.30239 17.6142 3.63555 17.7955 4.10229C17.9325 4.4547 18.0954 4.98419 18.1399 5.95914C18.188 7.01364 18.1982 7.32989 18.1982 10C18.1982 12.6701 18.188 12.9864 18.1399 14.0409C18.0954 15.0158 17.9325 15.5453 17.7955 15.8978C17.6142 16.3645 17.3974 16.6976 17.0475 17.0476C16.6976 17.3975 16.3644 17.6142 15.8977 17.7956C15.5453 17.9325 15.0158 18.0954 14.0408 18.1399C12.9865 18.188 12.6703 18.1982 9.99998 18.1982C7.32969 18.1982 7.01344 18.188 5.95914 18.1399C4.98415 18.0954 4.45466 17.9325 4.10229 17.7956C3.63551 17.6142 3.30235 17.3975 2.95244 17.0476C2.60253 16.6976 2.38579 16.3645 2.20443 15.8978C2.06748 15.5453 1.90457 15.0158 1.86007 14.0409C1.81196 12.9864 1.8018 12.6701 1.8018 10C1.8018 7.32989 1.81196 7.01364 1.86007 5.95918C1.90457 4.98419 2.06748 4.4547 2.20443 4.10229C2.38579 3.63555 2.60253 3.30239 2.95244 2.95248C3.30235 2.60257 3.63551 2.38583 4.10229 2.20443C4.45466 2.06752 4.98415 1.90461 5.9591 1.86011C7.0136 1.812 7.32985 1.80184 9.99998 1.80184ZM9.99998 0C7.28412 0 6.94362 0.0115116 5.87701 0.0601777C4.81259 0.108764 4.08569 0.277786 3.44958 0.525007C2.79199 0.780564 2.23432 1.1225 1.67839 1.67843C1.12246 2.23436 0.780524 2.79203 0.524967 3.44962C0.277746 4.08573 0.108725 4.81263 0.060138 5.87705C0.0114719 6.94362 0 7.28416 0 10C0 12.7159 0.0114719 13.0564 0.060138 14.123C0.108725 15.1874 0.277746 15.9143 0.524967 16.5504C0.780524 17.208 1.12246 17.7657 1.67839 18.3216C2.23432 18.8775 2.79199 19.2195 3.44958 19.475C4.08569 19.7223 4.81259 19.8913 5.87701 19.9399C6.94362 19.9885 7.28412 20 9.99998 20C12.7158 20 13.0564 19.9885 14.1229 19.9399C15.1874 19.8913 15.9143 19.7223 16.5504 19.475C17.208 19.2195 17.7656 18.8775 18.3216 18.3216C18.8775 17.7657 19.2194 17.208 19.475 16.5504C19.7222 15.9143 19.8912 15.1874 19.9398 14.123C19.9885 13.0564 20 12.7159 20 10C20 7.28416 19.9885 6.94362 19.9398 5.87705C19.8912 4.81263 19.7222 4.08573 19.475 3.44962C19.2194 2.79203 18.8775 2.23436 18.3216 1.67843C17.7656 1.1225 17.208 0.780564 16.5504 0.525007C15.9143 0.277786 15.1874 0.108764 14.1229 0.0601777C13.0564 0.0115116 12.7158 0 9.99998 0ZM9.99998 4.86487C7.16393 4.86487 4.86483 7.16397 4.86483 10C4.86483 12.8361 7.16393 15.1352 9.99998 15.1352C12.836 15.1352 15.1351 12.8361 15.1351 10C15.1351 7.16397 12.836 4.86487 9.99998 4.86487ZM9.99998 13.3334C8.15904 13.3334 6.66663 11.841 6.66663 10C6.66663 8.15908 8.15904 6.66667 9.99998 6.66667C11.8409 6.66667 13.3333 8.15908 13.3333 10C13.3333 11.841 11.8409 13.3334 9.99998 13.3334ZM16.538 4.66199C16.538 5.32474 16.0008 5.86201 15.338 5.86201C14.6753 5.86201 14.138 5.32474 14.138 4.66199C14.138 3.99924 14.6753 3.462 15.338 3.462C16.0008 3.462 16.538 3.99924 16.538 4.66199Z"
                    fill="white"
                />
            </svg>
        ),
        url: "https://www.instagram.com/",
        message: "Please enter your username so we can link your account to your profile.",
        warning: "",
    },
    {
        title: "Mastodon",
        key: "mastodon",
        icon: <img src="/Mastodon_logotype.png" alt="Mastodon" />,
        url: "https://www.mastodon.social/",
        message: "Please enter your username so we can link your account to your profile.",
        warning: "",
    },
    {
        title: "Threads",
        key: "threads",
        icon: <img src="/threads_logotype.png" alt="Threads" />,
        url: "https://www.threads.net/",
        message: "Please enter your username so we can link your account to your profile.",
        warning: "",
    },
    // {
    //     title: "Facebook",
    //     key: "facebook",
    //     icon: <img src="/facebook_logotype.png" alt="Mastodon" />,
    //     message: "We can pull your avatar and cover preferences from your Twitter, please enter your username here:",
    //     warning: "",
    // },
    {
        title: "Bluesky",
        key: "bluesky",
        icon: <img src="/bluesky_logotype.png" alt="Bluesky" />,
        url: "https://bsky.app/profile/",
        message: "Please enter your username so we can link your account to your profile.",
        warning: "",
    },
    {
        title: "StartPlaying",
        key: "startplaying",
        icon: <StartPlayingIcon hasTooltip={false} />,
        url: "https://startplaying.games/gm/",
    },
];

export const gamePreferencesQuestions = [
    {
        title: "How late is late when it comes to showing up at a #TTRPG session?",
        key: "lateness",
        options: ["5+ minutes", "15+ minutes", "30+ minutes", "1 hour+"],
        icon: "/game-preferences/hourglass.svg",
    },
    {
        title: "How important is it to you that games finish on time?",
        key: "finishOnTime",
        icon: "/game-preferences/kill_time.svg",
    },
    {
        title: "Importance of safety tools to me",
        key: "safetyTools",
        icon: "/game-preferences/warning_shield.svg",
    },
    {
        title: "LGBTQIA+ Friendly games?",
        key: "LGBTQ",
        icon: "/game-preferences/vomiting_unicorn.svg",
    },
    {
        title: "Am I ok with profanity:",
        key: "profanityLevel",
        icon: "/game-preferences/swearing_bubble.svg",
    },
    {
        title: "Am I ok with character death?",
        key: "characterDeath",
        icon: "/game-preferences/courage.svg",
    },

    {
        title: "Importance of rules",
        key: "ruleImportance",
        icon: "/game-preferences/reading_unicorn.svg",
    },
];

export const oldGamePreferencesQuestions = [
    {
        title: "Am I ok with profanity?",
        key: "profanityLevel",
    },
    {
        title: "Importance of rules",
        key: "ruleImportance",
    },
];

export const availabilityQuestions = [
    {
        title: "How late is late, when it comes to showing up at a #ttrpg session?",
        key: "lateness",
        options: ["5+ minutes", "15+ minutes", "30+ minutes", "1 hour+"],
    },
];

export const oldAvailabilityQuestions = [
    {
        title: "How important is it to you that games finish on time?",
        key: "finishOnTime",
        options: ["Super important.", "Somewhat important", "Who cares?", "It depends."],
    },
];

export const countryOptions = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D'Ivoire",
    "Croatia",
    "Cruise Ship",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Polynesia",
    "French West Indies",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Kyrgyz Republic",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Pierre & Miquelon",
    "Samoa",
    "San Marino",
    "Satellite",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "St Kitts & Nevis",
    "St Lucia",
    "St Vincent",
    "St. Lucia",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor L'Este",
    "Togo",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (US)",
    "Yemen",
    "Zambia",
    "Zimbabwe",
];

export const weekDays = [
    { day: "Sun", row: 6, column: 6, label: "Sunday", id: "sun" },
    { day: "Mon", row: 0, column: 0, label: "Monday", id: "mon" },
    { day: "Tue", row: 1, column: 1, label: "Tuesday", id: "tues" },
    { day: "Wed", row: 2, column: 2, label: "Wednesday", id: "weds" },
    { day: "Thu", row: 3, column: 3, label: "Thursday", id: "thurs" },
    { day: "Fri", row: 4, column: 4, label: "Friday", id: "fri" },
    { day: "Sat", row: 5, column: 5, label: "Saturday", id: "sat" },
];

export const weekDaysOrder = ["sun", "mon", "tues", "weds", "thurs", "fri", "sat"];
export const weekDaysLinked = weekDaysOrder.map((day, index, list) => ({
    id: day,
    day: weekDays.find((d) => d.id === day),
    next: () => {
        // if is not the last day, return the next one
        if (index < list.length - 1) return list[index + 1];

        // If it's the last day, return the first one
        return list[0];
    },
    nextDay: function () {
        const id = this.next();
        return weekDays.find((d) => d.id === id);
    },
}));

export const timeRange = [
    {
        start: "8 AM",
        end: "12 PM",
        icon: <CoffeeMakerTwoToneIcon />,
        row: 0,
        description: "morning",
        startRange: 8,
        endRange: 12,
    },
    {
        start: "12 PM",
        end: "4 PM",
        icon: <WbSunnyTwoToneIcon />,
        row: 1,
        description: "afternoon",
        startRange: 12,
        endRange: 16,
    },
    {
        start: "4 PM",
        end: "7 PM",
        icon: <Brightness6TwoToneIcon />,
        row: 2,
        description: "evening",
        startRange: 16,
        endRange: 19,
    },
    {
        start: "7 PM",
        end: "12 AM",
        icon: <NightlightTwoToneIcon />,
        row: 3,
        description: "night",
        startRange: 19,
        endRange: 24,
    },
    {
        start: "12 AM",
        end: "8 AM",
        icon: <BedTwoToneIcon />,
        row: 4,
        description: "late_night",
        startRange: 0,
        endRange: 8,
    },
];

export const AVATAR_REMOVED_PLACEHOLDER = "image_removed";

export const startPlayingRegexp = /^(https?:\/\/)?(www\.)?startplaying\.games\/.*/;
export const linkRegexp = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*$/;

export const PROFILE_IMAGE_MESSAGES = {
    ERROR: "Error",
    SUCCESS: "Success",
    ERROR_OCCURRED: "An error has occurred",
    CONTINUE: "Continue",
    UPLOAD_SUCCESS:
        "Your avatar was uploaded successfully. Don’t forget to save any changes to your profile before exiting.",
    UPLOAD_ERROR: "We weren’t able to upload your avatar at this time. Please try again later.",
    AVATAR_SUCCESS: "Avatar uploaded successfully.",
    UNABLE_UPLOAD: "It seems like we weren’t able to update your avatar at this time.",
    TRY_AGAIN: "Please try again.",
    INVALID_IMAGE: "Invalid image",
    INVALID_IMAGE_MSG:
        "Oops! It looks like your avatar upload did not meet our community standards. Please select a different image before trying again.",
    CHOOSE_DIFFERENT_IMG: "Choose A Different Image",
    CHOOSE_ANOTHER_IMG: "Choose Another Image",
    CANCEL: "Cancel",
    AVATAR_REMOVED: "Avatar removed successfully.",
    REMOVE_AVATAR: "Remove Avatar",
    REMOVE: "Remove",
    CONFIRM_REMOVE: "Are you sure that you want to remove your avatar?",
    AVATAR_REPLACE_INFO: "Once removed, it will be replaced with a random default avatar.",
    SAVE_BEFORE_EXIT: "Don’t forget to save any changes to your profile before exiting.",
    INVALID_EXTENSION_TITLE: "Invalid Image Extension",
    INVALID_SIZE_TITLE: "Invalid Image Size",
    INVALID_EXTENSION: "It seems you tried to upload a file with an invalid image extension.",
    INVALID_EXTENSION_INFO:
        "Please check if the file has a valid image extension (PNG or JPG) and try uploading again.",
    INVALID_SIZE: "It appears that the image you attempted to upload is too large.",
    INVALID_SIZE_INFO: "Please ensure that the file size meets our maximum limit of 10MB and try uploading again.",
    IMAGE_MODERATION_WARNING: "Image violates moderation policies",
};

export const emailRegexp = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
